export default class MetaData {
  field: any;

  value: number;

  constructor(obj: any = {}) {
    this.field = obj.field || '';
    this.value = obj.value || '';
  }

  public static of(obj: any = {}): MetaData {
    return new MetaData(obj || {});
  }
}
